import $ from 'jquery'

var magnusTimeout, bubbleStyleClass;

export default class Bubble {
  constructor() {
    var that = this;

    $(document).bind('bubble-show', function (e, config) {
      that.displayBubble(config)
    }).bind(that);

    $(document).bind('bubble-hide', function (e, data) {
      that.hideBubble()
    }).bind(that);

    /**
    * @name clearTimer
    * @function
    * @param {data}
    * @description: Clear the timer for magnus
    */
    $(document).bind('clear-timer', function (e, config) {
      clearTimeout(magnusTimeout)
    }).bind(that);
  }

  /**
  * @name displayBubble
  * @function
  * @param {data}
  * @description: Display the bubble
  */
  displayBubble(text) {
    let position = text.position ? (text.position === 'center' ? 'left' : text.position) : 'left',
      styleClass = text.styleClass ? text.styleClass : 'md',
      bubbleTimeout = 1000,
      timeout = text.timeout ? text.timeout : 0;

    magnusTimeout = setTimeout(function () {
      if ($('.speech').length === 0) {
        let body = ` 
      <div class='speech-bubble ${text.position} flex-center flex-column'>
        <div class="speech flex flex-full full-width flex-horizontal-center flex-vertical-bottom">
          <div class="bubble flex flex-center flex-column ${styleClass} ${position}"></div>
        </div>
        <div class="bubble-down-container full-width"><div class="bubble-down full-width"></div></div>
        <div class='dragon-container flex-full full-width'>
          <div class='dragon ${text.position}'></div>
        </div>
      </div>`;

      bubbleStyleClass = styleClass;

        if (text.position === 'right') {
          $('.right-box-content').html(body);
        } else if (text.position === 'center') {
          $('.qa-section-content').html(body);
        } else {
          $('.left-box-content').html(body);
        }

        $('.bubble').html(`<div class='bubble-content'>${text.data}</div>`);

        setTimeout(function () {
          $('.dragon').css({ 'height': '100%', 'width': '100%' });
        }, 500)
      } else {
        if (!text.continue) {
          $('.bubble-down, .bubble').css('opacity', '0');
          $('.bubble').css('height', '80px');
          $('.bubble-down').css('height', '0');
          $('.bubble').removeClass(bubbleStyleClass).addClass(styleClass)
          bubbleTimeout = 500;
        }

        setTimeout(function () {
          $('.bubble').html(`<div class='bubble-content'>${text.data}</div>`)
        }, 500)
      }

      setTimeout(function () {
        $('.bubble').css('height', $('.bubble').width());
        $('.bubble-down, .bubble').css('opacity', '1');
        $('.bubble-down').css('height', '100%');
      }, bubbleTimeout)
    }, timeout)

  }

  /**
  * @name hideBubble
  * @function
  * @param {}
  * @description: Hide the bubble
  */
  hideBubble() {
    clearTimeout(magnusTimeout)
    $('.speech').remove();
    $('.bubble-down').remove();
    $('.dragon').remove();
  }







}


// WEBPACK FOOTER //
// ./src/components/bubble.js